export default __webpack_public_path__ + "static/media/background-light.6d783147.jpg";